jQuery(document).ready(function($){

  if($('.o-image-slider__thumbnails')[0]){

    $('.o-image-slider__thumbnails').slick({
        dots: true,
        infinite: true, 
        arrows: false,
        centerMode: true,
        centerPadding: '306px',
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1050,
            settings: {
              centerPadding: '150px',
            }
          },
          {
            breakpoint: 780,
            settings: {
              centerPadding: '80px',
            }
          },
          {
            breakpoint: 600,
            settings: {
              centerMode: false,
              centerPadding: '0px',
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
        ]
    });
  }

});